import { render, staticRenderFns } from "./TimelinePhase.vue?vue&type=template&id=0319076a&scoped=true"
import script from "./TimelinePhase.vue?vue&type=script&lang=js"
export * from "./TimelinePhase.vue?vue&type=script&lang=js"
import style0 from "./TimelinePhase.vue?vue&type=style&index=0&id=0319076a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319076a",
  null
  
)

export default component.exports